import { create } from 'zustand';

// Default visible columns for the trucks table
const DEFAULT_VISIBLE_COLUMN_KEYS = [
  'status',
  'type',
  'make',
  'model',
  'year',
  'vin',
  'licensePlate',
  'currentDriver',
  'currentLoad',
];

interface TrucksListState {
  // Pagination
  page: number;
  limit: number;

  // Search
  search: string;

  // Table state
  visibleKeys: string[];
  columnFilters: Record<string, string>;
}

interface TrucksListActions {
  // Pagination actions
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;

  // Search actions
  setSearch: (search: string) => void;

  // Table actions
  setVisibleKeys: (keys: string[]) => void;
  setColumnFilter: (column: string, value: string) => void;
  setColumnFilters: (filters: Record<string, string>) => void;
  clearColumnFilters: () => void;

  // Utility actions
  resetFilters: () => void;
  resetAll: () => void;
}

type TrucksListStore = TrucksListState & TrucksListActions;

const initialState: TrucksListState = {
  page: 1,
  limit: 25,
  search: '',
  visibleKeys: DEFAULT_VISIBLE_COLUMN_KEYS,
  columnFilters: {},
};

export const useTrucksListStore = create<TrucksListStore>()((set) => ({
  ...initialState,

  // Pagination actions
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit, page: 1 }),

  // Search actions
  setSearch: (search) => set({ search, page: 1 }),

  // Table actions
  setVisibleKeys: (visibleKeys) => set({ visibleKeys }),
  setColumnFilter: (column, value) =>
    set((state) => ({
      columnFilters: { ...state.columnFilters, [column]: value },
    })),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  clearColumnFilters: () => set({ columnFilters: {}, page: 1 }),

  // Utility actions
  resetFilters: () => set({ search: '', columnFilters: {}, page: 1 }),
  resetAll: () => set(initialState),
}));
